import { render, staticRenderFns } from "./StairsPanel.vue?vue&type=template&id=7fbf49dd&scoped=true&"
import script from "./StairsPanel.vue?vue&type=script&lang=js&"
export * from "./StairsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbf49dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCombobox,VSheet})
